import router from '@/router'
const module = 'ROUTE_'
export const SET_BACK_ROUTE = module + 'SET_BACK_ROUTE'
export const SET_BACK_ROUTE_OVERRIDE = module + 'SET_BACK_ROUTE_OVERRIDE'
export const ROUTE_BACK = module + 'ROUTE_BACK'

// Deprecate use src/app/router/store/index.js
const actions = {
  [SET_BACK_ROUTE]: (context, route) => {
    context.commit(SET_BACK_ROUTE, route)
  },
  [SET_BACK_ROUTE_OVERRIDE]: (context, route) => {
    context.commit(SET_BACK_ROUTE_OVERRIDE, route)
  },
  [ROUTE_BACK]: (context) => {
    const route = context.state.routeBack
    const routeOverride = context.state.routeBackOverride

    if (routeOverride) {
      router.push(routeOverride)
      context.commit(SET_BACK_ROUTE_OVERRIDE, null)   // reset override value after usage
      return
    }
    if (route === 'user-audience-hub' || route === 'user-target-manager') {
      router.push({ name: route, params: { name: context.getters.username } })
    } else {
      router.push(route)
    }
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/app/appLogic/route/store/actions.js